/**
 * Signed-out view of `/itineraries` (issue #247). The page exists to manage
 * YOUR trips, so an account is intrinsic to it — anonymous visitors get a
 * sign-up CTA rather than a broken "My Itineraries" list. Deliberately makes
 * no `itinerary.listMine` call: that 401 was the bug. The public browse lives
 * at `/itineraries/discover` and is offered here as a tertiary action.
 */

import { Link, useNavigate } from 'react-router-dom';
import { PageContainer } from '../PageContainer';
import { Heading1, BodyText } from '../ui/Typography';
import { Button } from '../ui/Button';

export const ItinerariesSignedOutCTA = () => {
  const navigate = useNavigate();

  return (
    <div className="px-0 md:px-4 pt-2 pb-4">
      <PageContainer className="mt-2">
        <div className="mx-auto max-w-xl py-12 text-center">
          <Heading1>Plan your wine country trip</Heading1>

          <BodyText className="mt-3 block text-gray-600">
            Sign in or create an account to build, save, and share itineraries.
          </BodyText>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Button variant="primary" onClick={() => navigate('/login')}>
              Sign in
            </Button>
            <Button variant="outline" onClick={() => navigate('/login?signup=1')}>
              Create an account
            </Button>
          </div>

          <BodyText className="mt-6 block">
            <Link
              to="/itineraries/discover"
              className="text-primary-700 underline hover:text-primary-800"
            >
              Browse public itineraries
            </Link>
          </BodyText>
        </div>
      </PageContainer>
    </div>
  );
};
